import React from 'react';
import { Badge } from '../ui/badge';

/**
 * TokenHelperBar - Quick insert buttons for message tokens
 */
const TokenHelperBar = ({ onInsertToken, availableTokens }) => {
  const defaultTokens = [
    { token: '{{first_name}}', label: 'First Name', icon: '👤' },
    { token: '{{pack_name}}', label: 'Pack Name', icon: '📦' },
    { token: '{{link}}', label: 'Link', icon: '🔗' },
    { token: '{{event_name}}', label: 'Event', icon: '📅' },
    { token: '{{date}}', label: 'Date', icon: '📆' },
    { token: '{{time}}', label: 'Time', icon: '⏰' }
  ];

  const tokens = availableTokens || defaultTokens;

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-700 uppercase">
          Quick Insert Tokens
        </span>
        <span className="text-xs text-gray-500">
          Click to insert
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {tokens.map((item) => (
          <Badge
            key={item.token}
            onClick={() => onInsertToken && onInsertToken(item.token)}
            className="cursor-pointer bg-blue-100 text-blue-900 hover:bg-blue-200 transition-colors px-3 py-1"
            style={{ minHeight: '36px', display: 'flex', alignItems: 'center', gap: '4px' }}
          >
            <span>{item.icon}</span>
            <span className="text-xs font-medium">{item.label}</span>
          </Badge>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Tokens will be replaced with actual values when sent
      </p>
    </div>
  );
};

export default TokenHelperBar;
